import React from "react";
import {
  paymentInstructionContainer,
  paymentInstructionDisabled,
  bankName,
  bankAccount,
} from "./styles_vanilla.css";
import { PaymentInstructionStatusProps } from "./types";

export const PaymentInstructionStatus: React.FC<PaymentInstructionStatusProps> = ({
  bankName: bankNameProp,
  bankAccount: bankAccountProp,
  disabled,
}) => {
  return (
    <div
      data-testid="payment-instruction-status"
      className={`${paymentInstructionContainer} ${disabled ? paymentInstructionDisabled : ""}`}
    >
      <span className={bankName}>{bankNameProp}</span>
      <span className={bankAccount}>{bankAccountProp}</span>
    </div>
  );
};
